import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DialogLayout from '../../Layouts/ModalLayouts/DialogLayout';
import { FormTypes } from '../../redux/form';
import { clearModal, closeModal } from '../../redux/modal';
import { removeReservation } from '../../redux/user';

function AskCancelCoffinReserve() {
    const dispatch = useDispatch();
    const formData = useSelector(
        (state) => state.form[FormTypes.COFFIN_ESTIMATE]
    );

    return (
        <DialogLayout
            body={{ content: '견적을 취소 하시겠습니까?', props: {} }}
            actions={[
                {
                    content: '닫기',
                    props: {
                        onClick: () => {
                            dispatch(closeModal());
                        },
                    },
                },
                {
                    content: '불발됨',
                    props: {
                        style: { color: '#FF5160' },
                        onClick: () => {
                            // 현재 열려져 있는 Dialog 닫기
                            dispatch(clearModal());

                            // 요청된 견적 삭제
                            dispatch(
                                removeReservation({
                                    type: 'coffin',
                                    // idx: data,
                                })
                            );
                        },
                    },
                },
            ]}
        />
    );
}

export default AskCancelCoffinReserve;
